var Hotel = {
		 source:null,
		 roomCapacity:'',
		 capacityGreater:'',
         mapButton:null
};﻿

var HotelResult = {
	map : false,
	isHotelListNotEmpty : false,
	centerLatLon : null,
	centerLat : null,
	centerLon : null,
	showHotelMap : false
};